/**
 * Vite-exposed Supabase settings. Dashboards still label the public key "anon";
 * we accept both names so deploy envs stay compatible.
 */
export function getViteSupabaseUrl(): string {
  return (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.replace(/\/$/, "") ?? "";
}

export function getViteSupabasePublishableKey(): string {
  return (
    (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined) ||
    (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ||
    ""
  );
}
